/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../js/global";
import * as helper from "../../js/helper";
import full_loading from "../components/full-loading.vue";
import login_widget from "../widgets/login-widget.vue";
import register_widget from "../widgets/register-widget.vue";

const __vue_script__ = {
  components: {
    full_loading: full_loading,
    login_widget: login_widget,
    register_widget: register_widget,
  },
  name: "auth_page",
  props: {},
  data: function () {
    return {
      global,
      helper,
      frappe,
      loading: true,
      error: false,
      is_login:true
    };
  },
  methods: {
  },
  mounted() {
    global.emitter.emit("hide-full-loading");
    this.loading = false;
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("full_loading"),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "row justify-content-center" }, [
            _c("div", { staticClass: "col-8 text-end" }, [
              _c(
                "ul",
                {
                  staticClass: "nav nav-pills mb-3",
                  attrs: { id: "pills-tab", role: "tablist" }
                },
                [
                  !_vm.is_login
                    ? _c(
                        "li",
                        {
                          staticClass: "nav-item",
                          attrs: { role: "presentation" }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.helper.t("already have account?"))
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.is_login
                    ? _c(
                        "li",
                        {
                          staticClass: "nav-item",
                          attrs: { role: "presentation" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "nav-link",
                              class: _vm.is_login ? "active" : "",
                              attrs: { type: "button", role: "tab" },
                              on: {
                                click: function($event) {
                                  _vm.is_login = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.helper.t("Login")))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.is_login
                    ? _c(
                        "li",
                        {
                          staticClass: "nav-item",
                          attrs: { role: "presentation" }
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.helper.t("don't have account?")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.is_login
                    ? _c(
                        "li",
                        {
                          staticClass: "nav-item",
                          attrs: { role: "presentation" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "nav-link",
                              class: !_vm.is_login ? "active" : "",
                              attrs: { type: "button", role: "tab" },
                              on: {
                                click: function($event) {
                                  _vm.is_login = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.helper.t("Register now")))]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "row justify-content-center" }, [
            _vm.is_login
              ? _c("div", { staticClass: "col-8" }, [_c("login_widget")], 1)
              : _vm._e(),
            _vm._v(" "),
            !_vm.is_login
              ? _c("div", { staticClass: "col-8" }, [_c("register_widget")], 1)
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-bf6e8cd4_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"auth-page.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/pages/auth-page.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__